import { QueryList } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GCValidators } from '../../shared/validators/gc-validator';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../shared/services/auth.service';
import { SnackbarService } from '../../theme/components/snackbar/snackbar.service';
import { Subject } from 'rxjs';
var SignUpComponent = (function () {
    function SignUpComponent(route, translate, authService, router, snackBar) {
        this.route = route;
        this.translate = translate;
        this.authService = authService;
        this.router = router;
        this.snackBar = snackBar;
        this.ngUnsubscribe = new Subject();
        this.currentStep = 0;
        this.activateToken = '';
        this.boToken = '';
        this.registrationEmail = '';
        this.company = {};
        this.languagePreference = '';
        this.signupError = '';
        this.registerForm = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.minLength(2), GCValidators.validateEmail()]),
            password: new FormControl('', [Validators.required, GCValidators.validatePassword()]),
            confirmPassword: new FormControl('', [Validators.required, GCValidators.validatePasswordComparison()]),
        });
        this.profileForm = new FormGroup({
            branch: new FormControl('', [Validators.required]),
            title: new FormControl('none', [Validators.required]),
            prename: new FormControl('', [Validators.required, Validators.minLength(2)]),
            surname: new FormControl('', [Validators.required, Validators.minLength(2)]),
            acceptToS: new FormControl('', Validators.requiredTrue),
        });
        this.selectTeamAfterRegistration = false;
    }
    SignUpComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.takeUntil(this.ngUnsubscribe).subscribe(function (values) {
            _this.activateRoute(values);
        });
        this.route.queryParams.takeUntil(this.ngUnsubscribe).subscribe(function (params) {
            if (params.email && _this.currentStep === 1) {
                _this.registerForm.controls.email.patchValue(params.email);
            }
            if (params.selectTeam) {
                _this.selectTeamAfterRegistration = true;
            }
        });
    };
    SignUpComponent.prototype.activateRoute = function (params) {
        var _this = this;
        this.activateToken = params.token || '';
        this.boToken = params.botoken || '';
        // step 2->3 route
        if (params.data && params.data === 'verify') {
            // check if token is valid and get company data
            this.authService.getCompanyByVerificationToken(this.activateToken).then(function (data) {
                _this.currentStep = 3;
                _this.company = data.company;
                _this.translate.setDefaultLang(data.language);
                _this.languagePreference = data.language;
                if (data.boID) {
                    _this.profileForm.controls.branch.setValue(data.boID);
                    _this.profileForm.controls.branch.disable();
                }
                else {
                    if (!_this.company.branchoffices || _this.company.branchoffices.length === 0) {
                        _this.profileForm.controls.branch.setValidators(undefined);
                    }
                    else if (_this.company.branchoffices.length === 1) {
                        _this.profileForm.controls.branch.setValue(_this.company.branchoffices[0]._id);
                    }
                }
            });
        }
        else if (params.data) {
            // step 1 - This is language info
            this.translate.setDefaultLang(params.data);
            this.languagePreference = params.data;
            this.currentStep = 1;
        }
    };
    SignUpComponent.prototype.submitRegisterForm = function (e) {
        var _this = this;
        e.preventDefault();
        if (this.registerForm.valid) {
            this.registrationEmail = this.registerForm.value.email;
            this.authService
                .registerUser(this.registerForm.value.email, this.registerForm.value.password, this.languagePreference, this.activateToken, this.boToken, this.selectTeamAfterRegistration)
                .then(function (result) {
                _this.currentStep = 2;
                _this.translate.use(_this.translate.getDefaultLang());
            })
                .catch(function (response) {
                var error = response.body.error;
                if (error === 'Account is already active.') {
                    _this.signupError = 'accountActive';
                }
                if (error === 'E-Mail is already taken.') {
                    _this.signupError = 'emailTaken';
                    _this.currentStep = 2;
                    _this.translate.use(_this.translate.getDefaultLang());
                }
                if (error === 'Invalid token.') {
                    _this.signupError = 'invalidToken';
                }
                if (error === 'Specified e-mail domain is not allowed for this company.') {
                    _this.signupError = 'invalidDomain';
                }
                if (error === 'Direct registration to this company is not allowed.') {
                    _this.signupError = 'companyRegistrationBlocked';
                }
            });
        }
    };
    SignUpComponent.prototype.requestNewMail = function () {
        this.authService.resendActivationEmail(this.registrationEmail).then(function (result) { });
    };
    SignUpComponent.prototype.submitProfileForm = function () {
        var _this = this;
        if (this.profileForm.valid) {
            this.authService
                .activateAccount(this.profileForm.value.branch, this.profileForm.value.title === 'male' ? true : this.profileForm.value.title === 'female' ? false : null, this.profileForm.value.prename, this.profileForm.value.surname, this.activateToken)
                .then(function (result) {
                if (result.challengeID && (result.hasInvitation || _this.selectTeamAfterRegistration)) {
                    // If challengeID is in result, that means we should redirect to
                    _this.router.navigate(['challenge', result.challengeID, 'team']).then();
                }
                else {
                    _this.router.navigate(['/dashboard']);
                }
            });
        }
    };
    /**
     * On destroy cancel active subscriptions
     */
    SignUpComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return SignUpComponent;
}());
export { SignUpComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/sign-up/sign-up.component.ts.pre-build-optimizer.js